import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { withStore } from "@searchspring/snap-preact-components";

import "./Header.css";

@withStore
@observer
export class Header extends Component {
  render() {
    const { pagination, search, custom } = this.props.store;

    return (
      <header class="ss-header-container">
        {pagination.totalResults ? (
          <>
            <h2 class="h1 ss-title ss-results-title sr-headline1">
              {Resources.searchspring.searchHeader.weFound}
              <span class="ss-results-count-total">
                {pagination.totalResults}
              </span>
              {pagination.totalResults == 1 ? `${Resources.searchspring.searchHeader.result}` : `${Resources.searchspring.searchHeader.results}`}
              {search?.query && (
                <span>
                 {Resources.searchspring.searchHeader.for}
                  <span class="ss-results-query">"{search.query.string}"</span>
                </span>
              )}
            </h2>
          </>
        ) : (
          pagination.totalResults === 0 && (
            <h3 class="h1 ss-title ss-results-title ss-no-results-title">
              {search?.query ? (
                <>
                  <span>
                  {Resources.searchspring.searchHeader.noResultsFor}{" "}
                    <span class="ss-results-query">
                      "{search.query.string}"
                    </span>{" "}
                  </span>
                  <span class="ss-results-header-body">
                    {Resources.searchspring.searchHeader.doubleCheck}
                  </span>
                </>
              ) : (
                <span>{Resources.searchspring.searchHeader.noResults}</span>
              )}
            </h3>
          )
        )}
      </header>
    );
  }
}
